<template>
	<div class="user-retention">
		<PageHeader>
			<StatisticsLinkList />
		</PageHeader>
		<ManagingSection :isTable="true">
			<HorizontalSearch :blockElem="true" @init="init" @search="search">
				<SelectInput
					ref="period"
					label="기간"
					:usePeriod="true"
					@change="periodChange"
				/>
				<template v-slot:optionalButton="{ className }">
					<button
						type="button"
						:class="['btn-excel', className]"
						v-text="'EXCEL 다운로드'"
						@click="excelDown"
					/>
				</template>
			</HorizontalSearch>
		</ManagingSection>
		<p class="user-retention__notice">
			- 검색시 전일데이터 통계만 확인가능, 최대 한달 통계데이터 확인
			가능합니다.( 한달 데이터 통계 확인시 시작달 1일 ~ 다음달 1일까지
			검색 )
		</p>
		<ManagingSection :isTable="true">
			<table class="table-main">
				<thead>
					<tr v-for="(thList, listIdx) in thGroup" :key="listIdx">
						<template v-if="listIdx === 0">
							<th
								v-for="(th, idx) in thList"
								:key="th"
								:colspan="thGroup[1][idx].length"
								v-text="th"
							/>
						</template>
						<template v-else>
							<template v-for="(thList2, idx) in thList">
								<th
									v-for="th in thList2"
									:key="`${thGroup[0][idx]} ${th}`"
									v-text="th"
								/>
							</template>
						</template>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, idx) in list" :key="idx">
						<td>{{ item.setDate }}</td>
						<td>{{ item.createdAt }}</td>
						<td>{{ item.doc.newRegisterCount }}</td>
						<td>{{ item.doc.oldRegisterCount }}</td>
					</tr>
					<tr class="user-retention__sum">
						<td colspan="2">합계</td>
						<td>{{ newRegisterSum }}</td>
						<td>{{ oldRegisterSum }}</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
	</div>
</template>
<script>
	import PageHeader from '@/components/PageHeader';
	import StatisticsLinkList from '@/components/operation/StatisticsLinkList';
	import Excel from 'exceljs';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import HorizontalSearch from '@/components/HorizontalSearch.vue';
	import SelectInput from '@/components/SelectInput.vue';
	import moment from 'moment';

	export default {
		components: {
			PageHeader,
			StatisticsLinkList,
			ManagingSection,
			HorizontalSearch,
			SelectInput,
		},
		data() {
			return {
				thGroup: [
					['기간', '유저리텐션'],
					[
						['접속일', '배치일'],
						['신규', '기존'],
					],
				],
				list: [],
				startAt: '',
				endAt: '',
				newRegisterSum: '',
				oldRegisterSum: '',
			};
		},
		mounted() {
			this.setFilter(this.$route.query);
			this.setList();
		},

		methods: {
			setFilter({ start, end } = {}) {
				this.$refs.period.changePeriod({
					from: start || moment().date(1).format('YYYY-MM-DD'),
					to: end || moment().format('YYYY-MM-DD'),
				});
			},
			async setList() {
				try {
					const params = {
						startAt: this.startAt,
						endAt: this.endAt,
					};
					const { data } = await this.$axiosAdmin2.get(
						'/api/operation/statistic/register-summary/list',
						{ params }
					);
					const dataParsing = data.map(item => ({
						...item,
						createdAt: moment(item.createdAt).format('YYYY-MM-DD'),
						setDate: moment(item.createdAt)
							.subtract(1, 'days')
							.format('YYYY-MM-DD'),
						doc: JSON.parse(item.doc),
					}));
					this.list = [...dataParsing];
					this.getSum(data);
				} catch (err) {
					console.error(err);
					alert('리스트를 불러오는데 실패하였습니다.');
				}
			},
			getSum(data) {
				const { newRegisterSum, oldRegisterSum } = data.reduce(
					(acc, cur) => {
						const doc = JSON.parse(cur.doc);
						return {
							newRegisterSum:
								acc.newRegisterSum + doc.newRegisterCount,
							oldRegisterSum:
								acc.oldRegisterSum + doc.oldRegisterCount,
						};
					},
					{ newRegisterSum: 0, oldRegisterSum: 0 }
				);

				this.newRegisterSum = newRegisterSum;
				this.oldRegisterSum = oldRegisterSum;
			},
			init() {
				this.setFilter();
				this.setList();
			},
			search() {
				if (!this.validation()) return false;
				this.setList();
				this.setQuery();
			},
			setQuery() {
				const query = {
					start: this.startAt,
					end: this.endAt,
				};
				this.$router.replace({ query }).catch(() => {});
			},
			periodChange({ from, to }) {
				this.startAt = moment(from).add(1, 'days').valueOf() || '';
				this.endAt = moment(to).add(1, 'days').valueOf() || '';
			},
			async excelDown() {
				const workbook = new Excel.Workbook();

				workbook.creator = '글로우픽';
				workbook.lastModifiedBy = '글로우픽';
				workbook.created = new Date();
				workbook.modified = new Date();
				const sheet = workbook.addWorksheet('one');
				sheet.columns = [
					...this.thGroup[1]
						.map((thList, listIdx) =>
							thList.map(
								th => `${this.thGroup[0][listIdx]} ${th}`
							)
						)
						.flat(),
				].map((th, idx) => ({
					header: th,
					key: idx,
				}));

				sheet.addRows(
					this.list.map(item => [
						item.setDate,
						item.createdAt,
						item.doc.newRegisterCount,
						item.doc.oldRegisterCount,
					])
				);
				sheet.addRow([
					'합계',
					'-',
					this.newRegisterSum,
					this.oldRegisterSum,
				]);

				const start = moment(this.startAt).format('YYYY-MM-DD');
				const end = moment(this.endAt).format('YYYY-MM-DD');
				const data = await workbook.xlsx.writeBuffer();
				const blob = new Blob([data], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				});
				const url = window.URL.createObjectURL(blob);
				const anchor = document.createElement('a');
				anchor.href = url;
				anchor.download = `글로우픽_유저별리텐션 통계(${start} ~ ${end})_${new Date().getTime()}.xlsx`;
				anchor.click();
				window.URL.revokeObjectURL(url);

				const params = {
					admin_log: {
						path: this.$router.currentRoute.fullPath,
						action: 'CSV',
						doc: { 'api-url': this.reqUrl },
					},
				};
				await this.$axiosSupport.post('/admin/admin_log', params);
			},
			validation() {
				const startDate = moment(this.startAt);
				const endDate = moment(this.endAt);

				if (!startDate || !endDate) {
					alert('날짜를 입력해 주세요');
					return false;
				}
				if (startDate.valueOf() === endDate.valueOf()) {
					alert(
						'전일기준 데이터이기 때문에 종료일과 시작일이 같을수 없습니다.\n 예) 8월1일 통계 - 8월1일 ~ 8월2일 검색'
					);
					return false;
				}
				if (startDate.valueOf() > endDate.valueOf()) {
					alert('종료일시는 시작일시보다 빠를 수 없습니다.');
					return false;
				}
				if (!!startDate && !!endDate) {
					const monthDifference = startDate.add(1, 'month');

					if (endDate.valueOf() > monthDifference.valueOf()) {
						alert('최대 한달까지 검색 가능합니다');
						return false;
					}
					return true;
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.user-retention {
		&__sum {
			background-color: #f4f7fa;
		}
		&__notice {
			margin-top: 20px;
		}
	}
</style>
